export default __webpack_public_path__ + "static/media/save.4ae55a3f.svg";